import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import DevExpress from 'devextreme';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { confirm } from 'devextreme/ui/dialog';
import { Apiservice } from '../../services/api.service';
import { Soggetto } from '../popup-gestione-fir-digitali/interfaces';
import { UtilityService } from '../../services/utility.service';
import { Subscription } from 'rxjs';
import { ComponentService } from '../../services/component.service';
import { Sede } from '../../views/gestione-formulari/interfaces';
import { HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-gestione-dispositivi',
  templateUrl: './gestione-dispositivi.component.html',
  styleUrls: ['./gestione-dispositivi.component.css']
})
export class GestioneDispositiviComponent implements OnInit {
  @ViewChild('tabella', { static: false }) tabella!: DxDataGridComponent;
  @Input() soggetto: Soggetto
  @Input() elimina: boolean = true
  @Input() seleziona: boolean = false
  @Input() aggiungi: boolean = true
  @Input() isUlSelection: boolean = true
  @Input() ulSelected: Sede | null = null
  @Input() isStatic: boolean = false
  @Input() dataSource: DataSource | any[];
  @Output() outEvent: EventEmitter<Record<string, any>> = new EventEmitter<Record<string, any>>()
  ulSelectItems: DataSource
  columns: Array<DevExpress.ui.dxDataGridColumn | string> = [];
  constructor(private readonly Apiservice: Apiservice, private readonly UtilityService: UtilityService, private readonly ComponentService: ComponentService, private readonly loader: NgxSpinnerService) {
    this.buildCol()
  }

  async ngOnInit() {
    if (!this.soggetto) { } else {
      await this.buildDataSource()
    }
  }
  onToolbarPreparing(e: any) {
    const toolbarItems = e.toolbarOptions.items;

    if (this.isUlSelection) toolbarItems.unshift({
      location: 'center',
      template: 'ulSelect'
    });
    if (this.aggiungi) toolbarItems.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'plus',
        text: 'Associa nuovo dispositivo',
        onClick: () => this.onAdd()
      }
    });
    if (!this.isStatic) toolbarItems.push(
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'refresh',
          hint: 'Ricarica',
          onClick: () => this.tabella.instance.refresh()
        }
      }
    );
  }
  onAziendaChanged(e: any) {
    this.ulSelected = e.value;
    this.tabella.instance.pageIndex(0);
    this.tabella.instance.refresh();
  }

  onAdd() {
    const guid = Math.random().toString().replace("0.", "")
    const instanceData = {
      soggetto: this.soggetto,
      unita_locale: this.ulSelected
    }
    this.ComponentService.setNewPopUp(guid, 'AssociaDispositivoComponent', null, '1200', null, instanceData, false, true, `Associa Nuovo Dispositivo`,)
    const sub: Subscription = this.ComponentService.outputComponent.subscribe(async (out) => {
      if (out && out.guid === guid) {
        console.log('AssociaDispositivoComponent', out)
        if (out.name === "closePopup") if (this.tabella) this.tabella.instance.refresh()
      }
    })
  }
  onSelectionChanged(event) {
    this.outEvent.emit({
      name: 'onSelectionChanged',
      event
    })
  }
  async inviaMsgFirebase(data) {
    console.log(data)
    const guida = Math.random().toString().replace('0.', '');
    let msgToSend = ''
    let titoloToSend = ''
    const instancedData = {
      service: 'messaggioSemplice',
      api: '',
      filterKey: '',
      queryString: '',
      type: 'simpleForm',
      nCol: 1,
      remoteOperation: false,
      toolbarTop: false,
      toolbarBottom: true,
      CustomButtonSetForm: [
        {
          location: 'after',
          stylingMode: 'text',
          widget: 'dxButton',
          locateInMenu: 'never',
          text: 'Invia',
          icon: 'dx-icon-message',
          event: 'inviaMsgFirebase',
        },
        {
          location: 'after',
          stylingMode: 'text',
          widget: 'dxButton',
          locateInMenu: 'never',
          text: 'Annulla',
          icon: 'glyphicon glyphicon icon-annulla-form',
          event: 'annullaMsgFirebase',
        },
      ],
      standardBtnBottom: [], //Rimuovo pulsanti footer default metodo 1
      disableEditForm: true, //Rimuovo pulsanti footer default metodo 2
    };

    this.ComponentService.setNewPopUp(guida, 'NewNicaFormComponent', null, '550', null, instancedData, false, true, `Notifica a ${data.utente_nome_cognome}`, 'center');
    const sub: Subscription = this.ComponentService.outputComponent.subscribe(async (res) => {
      if (res.guid === guida) {
        if (res.name === "onValueChanged") {
          msgToSend = res.formData.msgGrafico
          titoloToSend = res.formData.titoloGrafico
        }
        if (res.name === 'inviaMsgFirebase') {
          const url = "https://rentrincloud.it/api/ca-rentri/SendFirebaseNotification";
          const token = data.notification_callback_parameters.token || null
          if (!token) return
          try {
            this.loader.show()
            await fetch(url, {
              method: 'POST',
              headers: {
                "Content-Type": "application/json",
                "Authorization": "Basic TmljYVVzZXI6OFttXmQkMmZQekdQS30oN1UyYzQ="
              },
              body: JSON.stringify({
                "message": {
                  "token": token,
                  "notification": {
                    "title": titoloToSend,
                    "body": msgToSend
                  },
                  "data": data.notification_callback_parameters
                }
              })
            });

          } catch (error) {
          } finally {
            this.loader.hide()
            this.ComponentService.destroyCurrentOpenPopUpByGuid(guida);
            sub.unsubscribe()
          }
        }
        if (res.name === 'annullaMsgFirebase') {
          this.ComponentService.destroyCurrentOpenPopUpByGuid(guida);
          sub.unsubscribe()
        }
      }
    });

  }
  //!--------------------------------------------------------------------------------------------------------------
  private async buildDataSource() {
    if (!this.soggetto) return;
    // const ul = await this.Apiservice.GetApi(`Sede/${this.soggetto.id}`) as any[]
    // if (ul) this.ulSelectItems = [...this.ulSelectItems, ...ul]
    this.ulSelectItems = new DataSource({
      store: new CustomStore({
        load: async (options) => {
          try {
            const skip = options.skip || 0;
            const take = options.take || 50;

            // QUERY COMPLETA
            const query =
              `?$skip=${skip}&$top=${take}&$count=true`

            const { items, totalCount } = await this.Apiservice.GetApi(`Sede/${this.soggetto.id}${query}`) as { items: any[], totalCount: number };
            return {
              data: items,
              totalCount
            };
          } catch (err) {
            console.log(err)
            return Promise.reject(err.error.descrMessage);
          }
        }
      })
    });
    if (!this.isStatic) this.dataSource = new DataSource({
      key: 'credentials_id',
      store: new CustomStore({
        load: async (options) => {
          try {

            const skip = options.skip || 0;
            const take = options.take || 50;
            const filter = options.filter || undefined
            console.log(options)
            let orderBy = "data_registrazione desc";

            // ORDER BY
            if (options.sort && options.sort.length > 0) {
              const s = options.sort[0];
              orderBy = `${s.selector} ${s.desc ? "desc" : "asc"}`;
            }

            // SEARCH → COSTRUIAMO IL FILTRO ODATA
            let search = '';
            if (filter) {
              let tmp = ''
              filter.forEach((f) => {
                if (Array.isArray(f)) tmp += `(${f[1]}(tolower(${f[0]}), tolower('${f[2]}')))`
                if (typeof f === 'string') tmp += ` ${f} `
              })
              if (!this.ulSelected) search += `&$filter=(${tmp})`;
              else search += `&$filter=(${tmp})and (contains(tolower(num_iscr_sito), tolower('${this.ulSelected.idSedeRentri}')))`;
            } else {
              if (this.ulSelected) search += `&$filter=(contains(tolower(num_iscr_sito), tolower('${this.ulSelected.idSedeRentri}')))`;
            }

            // QUERY COMPLETA
            const query =
              `?idSoggetto=${this.soggetto.id}` +
              `&identificativo_soggetto=${this.soggetto.codiceFiscale}` +
              `&$skip=${skip}&$top=${take}&$count=true` +
              `&$orderby=${orderBy}` +
              search;

            const { items, totalCount } = await this.Apiservice.GetApi(
              `ca-rentri/CredentialDevices${query}`
            ) as { items: any[], totalCount: number };

            if (options.group && options.group.length) {
              const groupField = options.group[0].selector;
              const groupedData = this.buildGroupedData(items, groupField);
              return {
                data: groupedData,
                totalCount
              };
            }
            return {
              data: items,
              totalCount
            };
          } catch (err) {
            console.log(err)
            return Promise.reject(err.error.descrMessage);
          }
        },
        remove: async (data) => {
          if (!data) return null;
          try {
            const isPresente = this.tabella.instance.getDataSource().items().map((val) => {
              const itm = val.items as Array<Record<string, any>>
              return itm.filter((i) => i.credentials_id === data.credentials_id)[0]
            }).filter(val => val !== null && val !== undefined)
            if (isPresente.length > 1) {
              await this.Apiservice.DeleteApi(
                `ca-rentri/RimuoviAssociazioneCredenziali?idSoggetto=${this.soggetto.id}&credentials_id=${data.credentials_id}&num_iscr_sito=${data.num_iscr_sito}`
              );
            } else {
              await this.Apiservice.DeleteApi(
                `ca-rentri/DeleteCredenziali?idSoggetto=${this.soggetto.id}&credentials_id=${data.credentials_id}`
              );
            }
          } catch {
            return Promise.reject("Errore interno");
          }
        },
      }),

      paginate: true,
      pageSize: 50,
      searchExpr: [
        "data_registrazione",
        "utente_nome_cognome",
        "manufacturer",
        "model",
        "name",
        "app_name",
        'credentials_id'
      ],
    });
  }
  private buildCol() {
    this.columns = [
      {
        dataField: 'inviaMsg',
        caption: 'Invia',
        dataType: 'string',
        allowSorting: false,
        allowEditing: false,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowSearch: false,
        width: '3rem',
        alignment: 'center',
        cellTemplate: 'btnInviaMsg',
      },
      {
        dataField: 'app_name',
        caption: 'APP',
        width: '10rem',
        dataType: 'string',
        allowSorting: true,
        cellTemplate: (container, opt) => container.append(opt.data.app_package_name === 'com.rentri' ? 'Rentri Nica' : opt.data.app_name)
      },
      {
        dataField: 'credentials_id',
        caption: 'Credenziali',
        width: '6rem',
        alignment: 'center',
        dataType: 'string',
        allowSorting: true,
      },
      {
        dataField: 'utente_nome_cognome',
        caption: 'Nome Cognome',
        dataType: 'string',
        allowSorting: true,
      },
      {
        dataField: 'manufacturer',
        caption: 'Tipo Dispositivo',
        dataType: 'string',
        allowSorting: true,
        cellTemplate: (container, opt) => container.append(`${this.UtilityService.capitalizeWords(opt.data.manufacturer)} ${opt.data.model}`)
      },
      {
        dataField: 'name',
        caption: 'Nome Dispositivo',
        dataType: 'string',
        allowSorting: true,
      },
      {
        dataField: 'denominazione_operatore',
        caption: 'Azienda',
        dataType: 'string',
        allowSorting: true,
      },
      {
        dataField: 'denominazione_sito',
        caption: 'U.L',
        dataType: 'string',
        allowSorting: false,
        visible: false,
        showInColumnChooser: false,
        groupIndex: 0,
      },
      {
        dataField: 'indirizzo',
        caption: 'Indirizzo',
        dataType: 'string',
        allowSorting: true,
      },
      {
        dataField: 'comune_descrizione',
        caption: 'Comune',
        dataType: 'string',
        allowSorting: true,
      },
    ];
  }
  private buildGroupedData<T>(items: T[], field: keyof T) {
    const map = new Map<any, T[]>();

    for (const item of items) {
      const key = item[field];
      if (!map.has(key)) {
        map.set(key, []);
      }
      map.get(key)!.push(item);
    }

    return Array.from(map.entries()).map(([key, values]) => ({
      key,
      items: values,
      count: values.length
    }));
  }

}

